import { useNavigate } from 'react-router-dom';
import shared from '@/styles/public.module.css';
import styles from './FinalCTASection.module.css';

const FinalCTASection = () => {
  const navigate = useNavigate();

  return (
    <section
      className={`${shared.section} ${shared.sectionDark} ${styles.final}`}
      data-testid="final-cta-section"
    >
      <div className={shared.wrap}>
        <h2>Find out what your case is worth today.</h2>
        <p>
          Applying is free, takes about five minutes, and doesn&rsquo;t obligate you
          to accept anything.
        </p>
        <div className={styles.row}>
          <button
            type="button"
            className={`${shared.btn} ${shared.btnAccent} ${shared.btnLg} ${styles.rowBtn}`}
            onClick={() => navigate('/apply')}
            data-testid="final-cta-apply-btn"
          >
            Apply for funding
          </button>
          <button
            type="button"
            className={`${shared.btn} ${shared.btnOnDark} ${shared.btnLg} ${styles.rowBtn}`}
            onClick={() => navigate('/login')}
            data-testid="final-cta-login-btn"
          >
            Log in
          </button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
